import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
  PRODUCT_SOURCE_REQUEST,
  PRODUCT_SOURCE_CREATE,
  PRODUCT_SOURCE_DELETE,
  PRODUCT_SOURCE_EDIT,
  PRODUCT_SOURCE_STATE_CHANGE
} from "../../../../_utils/constants/ProductCatalog";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const ProductSource = ({
  auth: { auth, isAuthenticated },
  ProductSource: { valueList, isCreated, isDeleted, isEdited, isLoading },
  fetchProductSource,
  submitProductSourceCreate,
  submitProductSourceDelete,
  submitProductSourceEdit,
  changeReducerState
}) => {

  // states declarations
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [deleteProductSourceId, setDeleteProductSourceId] = useState('');
  const [editProductSourceId, setEditProductSourceId] = useState('');
  const [editProductSource, setEditProductSource] = useState('');

  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchProductSource(auth[0].token);
    }
  }, [auth, isAuthenticated]);

  // use effect function called after api success
  useEffect(() => {
    if (isCreated === true) {
      toast.success("ProductSource Created Successfully.");
      fetchProductSource(auth[0].token);
      changeReducerState();
    }
    if (isDeleted === true) {
      toast.success("ProductSource Deleted Successfully.");
      fetchProductSource(auth[0].token);
      changeReducerState();
    }
    if (isEdited === true) {
      toast.success("ProductSource Data Updated Successfully.");
      fetchProductSource(auth[0].token);
      changeReducerState();
    }
  }, [isCreated, isDeleted, isEdited]);

  // function to open create modal
  const showCreateModal = () => {
    setCreateModalOpen(true);
  };

  // function to close create modal
  const hideCreateModal = () => {
    setCreateModalOpen(false);
  };

  // function called for input value change of create modal
  const handleCreateModalChange = (e) => {
    setInputVal(e.target.value);
  }

  // function called for create age demographic create api
  const handleCreateModalSubmit = (e) => {
    e.preventDefault();
    if (inputVal === '') {
      toast.error("ProductSource name cannot be empty.");
    } else {
      submitProductSourceCreate({
        "data": {
          "ProductSouce": inputVal,
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeleteProductSourceId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeleteProductSourceId('');
    setConfirmDeleteModal(false);
  };

  // function called for delete age demographic delete api
  const handleConfirmDeleteSubmit = () => {
    submitProductSourceDelete({
      "ProductSourceId": deleteProductSourceId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }

  // function called on edit icon click
  const handleEditClick = (data) => {
    setEditProductSourceId(data.productSourceId);
    setEditProductSource(data.productSouce);
  }

  // function called to save edited data
  const handleEditSaveClick = (data) => {
    if (editProductSource === '') {
      toast.error("ProductSource name cannot be empty.");
    } else {
      submitProductSourceEdit({
        "data": {
          "ProductSourceId": data.productSourceId,
          "ProductSouce": editProductSource,
        },
        "token": auth[0].token
      });
      setEditProductSourceId('');
      setEditProductSource('');
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <MainWrapper>
      <Loader loading={isLoading}>
        <div className="container">

          <div className="sub-header mt-5 mb-3">
            <h2>ProductSource</h2>
            <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
            <Create
              variant="primary"
              title={`ProductSource`}
              createModalOpen={createModalOpen}
              showCreateModal={showCreateModal}
              hideCreateModal={hideCreateModal}
              inputVal={inputVal}
              handleCreateModalChange={handleCreateModalChange}
              handleCreateModalSubmit={handleCreateModalSubmit}
            />
          </div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>ProductSource</th>
                <th width="50">Delete</th>
              </tr>
            </thead>
            <tbody>
              {valueList && valueList.length > 0 ? (
                valueList.map((item, index) => (
                  <tr key={index}>
                    {editProductSourceId === item.productSourceId ? (
                      <td>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control type="text" value={editProductSource} onChange={(evt) => setEditProductSource(evt.target.value)} />
                            <Button variant="outline-secondary">
                              <Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
                            </Button>
                          </InputGroup>
                        </Form.Group>
                      </td>
                    ) : (
                      <td>
                        {item.productSouce}
                        <Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
                      </td>
                    )}
                    <td>
                      <ConfirmDelete variant="primary" title={`ProductSource`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.productSourceId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>
                    No Data Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Loader>
    </MainWrapper>
  );
}

const mapStateToProps = ({ auth, ProductSource }) => {
  return {
    auth,
    ProductSource
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchProductSource: (token) => dispatch({ type: PRODUCT_SOURCE_REQUEST, token }),
    submitProductSourceCreate: (data) => dispatch({ type: PRODUCT_SOURCE_CREATE, payload: data }),
    submitProductSourceDelete: (data) => dispatch({ type: PRODUCT_SOURCE_DELETE, payload: data }),
    submitProductSourceEdit: (data) => dispatch({ type: PRODUCT_SOURCE_EDIT, payload: data }),
    changeReducerState: () => dispatch({ type: PRODUCT_SOURCE_STATE_CHANGE })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductSource);